module.exports = __webpack_public_path__ + "img/mail.2ddaef02.png";